module.exports = __webpack_public_path__ + "img/card-visa.7020f830.png";